(function () {
  'use strict';

  const runtimePromises = new Map();
  const initializedSections = new WeakSet();

  const loadScript = (url) => {
    if (!url) return Promise.reject(new Error('Recommended floors asset URL is missing.'));
    if (runtimePromises.has(url)) return runtimePromises.get(url);

    const promise = new Promise((resolve, reject) => {
      let script = [...document.scripts].find((candidate) => candidate.src === new URL(url, document.baseURI).href);
      const handleLoad = () => {
        script.dataset.recommendedFloorsLoaded = 'true';
        resolve();
      };
      const handleError = () => reject(new Error(`Unable to load ${url}.`));

      if (script?.dataset.recommendedFloorsLoaded === 'true') {
        resolve();
        return;
      }

      if (!script) {
        script = document.createElement('script');
        script.src = url;
        script.async = true;
        script.dataset.recommendedFloorsRuntime = 'true';
      }

      script.addEventListener('load', handleLoad, { once: true });
      script.addEventListener('error', handleError, { once: true });
      if (!script.isConnected) document.head.appendChild(script);
    }).catch((error) => {
      runtimePromises.delete(url);
      throw error;
    });

    runtimePromises.set(url, promise);
    return promise;
  };

  const loadSectionRuntime = async (section) => {
    if (section.dataset.recommendedFloorsRuntime === 'ready') return;
    if (section._recommendedFloorsRuntimePromise) return section._recommendedFloorsRuntimePromise;

    section.dataset.recommendedFloorsRuntime = 'loading';
    section._recommendedFloorsRuntimePromise = loadScript(section.dataset.recommendedFloorsRendererUrl)
      .then(() => loadScript(section.dataset.recommendedFloorsScriptUrl))
      .then(() => {
        section.dataset.recommendedFloorsRuntime = 'ready';
      })
      .catch((error) => {
        section.dataset.recommendedFloorsRuntime = 'error';
        const status = section.querySelector('.recommended-floors__preview-status');
        if (status) status.textContent = 'Preview temporarily unavailable';
        console.error('Unable to load the recommended floors experience:', error);
      });

    return section._recommendedFloorsRuntimePromise;
  };

  const setupSection = (section) => {
    if (initializedSections.has(section)) return;
    initializedSections.add(section);

    const trigger = () => loadSectionRuntime(section);
    section.addEventListener('pointerenter', trigger, { once: true, passive: true });
    section.addEventListener('focusin', trigger, { once: true, passive: true });
    section.addEventListener('touchstart', trigger, { once: true, passive: true });

    if (!('IntersectionObserver' in window)) {
      trigger();
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      if (!entries.some((entry) => entry.isIntersecting)) return;
      observer.disconnect();
      trigger();
    }, { rootMargin: '400px 0px' });
    observer.observe(section);
  };

  const scan = (root = document) => {
    root.querySelectorAll?.('.recommended-floors[data-recommended-floors-script-url]').forEach(setupSection);
  };

  scan();
  document.addEventListener('shopify:section:load', (event) => scan(event.target));
})();
